export default __webpack_public_path__ + "static/pandabtm_landing-fffde1706dfd7da7af4eb1658f6f9c9c.png";